import { useEffect, useRef, useState } from 'react';

// Seta "voltar ao topo" — CÓPIA do painel antigo (`a[href="#top"]` do style.css + o script da lista):
//  - caixa 40x40 cinza rgb(154,154,154) com a imagem `scroll-top.png` (seta) centralizada,
//    colada na margem direita (10 px), a 92% da altura da tela;
//  - aparece (fade) depois de rolar 300 px e some (fade) ao voltar;
//  - clique sobe com rolagem SUAVE de 800 ms (o `animate({scrollTop:0}, 800)` do jQuery, easing "swing").
// A imagem vem do R2 público (img/sistema/scroll-top.png, copiada do painel antigo). Na tela do
// imóvel o botão redondo de salvar fica no mesmo canto — nela a seta desloca pra esquerda dele.
// O Layout reserva bastante espaço em branco no fim da página pra a seta nunca cobrir conteúdo.
const IMAGEM = 'https://cdn.eimovel.com.br/img/sistema/scroll-top.png';
const DURACAO_MS = 800;

// easing "swing" do jQuery
const swing = (p) => 0.5 - Math.cos(p * Math.PI) / 2;

export default function VoltarAoTopo() {
  const [visivel, setVisivel] = useState(false);
  const [ladoDoSalvar, setLadoDoSalvar] = useState(false);
  const animacao = useRef(null);

  useEffect(() => {
    function aoRolar() {
      setVisivel(window.scrollY > 300);
      setLadoDoSalvar(Boolean(document.querySelector('.botao-salvar-flutuante')));
    }
    aoRolar();
    window.addEventListener('scroll', aoRolar, { passive: true });
    return () => {
      window.removeEventListener('scroll', aoRolar);
      if (animacao.current) cancelAnimationFrame(animacao.current);
    };
  }, []);

  function subir(e) {
    e.preventDefault();
    const inicio = window.scrollY;
    const t0 = performance.now();
    if (animacao.current) cancelAnimationFrame(animacao.current);
    const passo = (agora) => {
      const p = Math.min(1, (agora - t0) / DURACAO_MS);
      window.scrollTo(0, inicio * (1 - swing(p)));
      animacao.current = p < 1 ? requestAnimationFrame(passo) : null;
    };
    animacao.current = requestAnimationFrame(passo);
  }

  return (
    <a
      href="#top"
      aria-label="Voltar ao topo"
      title="Voltar ao topo"
      onClick={subir}
      style={{
        position: 'fixed',
        top: '92%',
        right: ladoDoSalvar ? 80 : 10,
        width: 40,
        height: 40,
        zIndex: 1030,
        background: `url(${IMAGEM}) center center no-repeat rgb(154, 154, 154)`,
        opacity: visivel ? 1 : 0,
        pointerEvents: visivel ? 'auto' : 'none',
        transition: 'all 0.25s ease-in-out 0s, opacity 0.4s ease',
      }}
    />
  );
}
